import { baseUrl } from '../utils/request'
import { languageApiLocale, languageRequestCode, readLanguage } from '../utils/locale'

const REQUEST_TIMEOUT = 15000

export const getFeedbackMessagePage = ({
  uid,
  pageNum = 1,
  pageSize = 10,
  lastTime = '',
  firstTime = '',
  headers = {}
}) => {
  return customerRequest('/other/getFeedbackMsgList', {
    uid,
    pageNum,
    pageSize,
    lastTime,
    firstTime,
    hideLoad: 10
  }, { headers })
}

export const sendFeedbackMessage = ({
  category = '其他',
  content,
  picture = '',
  uid,
  consutomId = '',
  consutomType = '',
  callType = '',
  headers = {}
}) => {
  return customerRequest('/other/feedback', {
    category,
    content,
    picture,
    uid,
    consutomId,
    consutomType,
    callType
  }, { headers })
}

export const uploadFeedbackImageFile = formData => {
  return customerRequest('/other/uploadImage', {}, {
    method: 'POST',
    body: formData
  })
}

export const initializeCustomerMessage = uid => {
  return customerRequest('/other/getFirstConsutomMes', { uid, hideLoad: 10 })
}

export const getCurrentCustomer = uid => {
  return customerRequest('/other/clickConsutom', { uid, hideLoad: 10 })
}

export const quitCurrentCustomer = consutomId => {
  return customerRequest('/other/quitConsutom', { consutomId, hideLoad: 10 })
}

async function customerRequest(path, params = {}, options = {}) {
  const controller = new AbortController()
  const timeout = window.setTimeout(() => controller.abort(), REQUEST_TIMEOUT)
  const url = new URL(`${baseUrl}${path}`)
  const token = window.localStorage.getItem('token') || ''
  const requestParams = { ...params, token, _locale: languageApiLocale(readLanguage()) }

  Object.keys(requestParams).forEach(key => {
    const value = requestParams[key]
    if (value !== null && value !== undefined && value !== '') {
      url.searchParams.append(key, String(value))
    }
  })

  try {
    const response = await fetch(url.toString(), {
      ...options,
      method: options.method || 'GET',
      headers: {
        'Accept-Language': languageRequestCode(readLanguage()),
        ...(options.headers || {})
      },
      signal: controller.signal
    })
    const text = await response.text()
    let data = text
    try {
      data = text ? JSON.parse(text) : undefined
    } catch (error) {
      // 非 JSON 响应按原始文本返回，与参考项目保持一致。
    }
    if (!response.ok) {
      const requestError = new Error(`HTTP ${response.status}`)
      requestError.status = response.status
      requestError.data = data
      throw requestError
    }
    const visitorId = response.headers.get('X-Support-Visitor') || response.headers.get('x-support-visitor')
    if (visitorId && data && typeof data === 'object' && !data.visitorId) {
      data.visitorId = visitorId
    }
    return data
  } finally {
    window.clearTimeout(timeout)
  }
}
